import { Button, Container, Group, Text, Title } from '@mantine/core';
import classes from './NotFound.module.css';

export function NotFound() {
  return (
    <Container className={classes.root}>
      <div className={classes.label}>404</div>
      <Title className={classes.title}>
        {' '}
        לצערנו לא נמצא דף בכתובת שהוכנסה.
      </Title>
      <Text c="dimmed" size="lg" ta="center" className={classes.description}>
        במידה ותקלה זו חוזרת על עצמה, אנא פנה לתמיכה.
      </Text>
      <Group justify="center">
        <Button
          variant="subtle"
          size="md"
          onClick={() => (window.location.href = '/')}
        >
          קח אותי לדף הבית
        </Button>
      </Group>
    </Container>
  );
}
